import { createRouter, createWebHistory } from 'vue-router'
import DuyfkenView from '../views/DuyfkenView.vue'
const routes = [
  {
    path: '/',
    name: 'duyfken-360',
    component: DuyfkenView
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router